import { SingletonManagerClass } from './src/SingletonManagerClass.js';

export { SingletonManagerClass } from './src/SingletonManagerClass.js';

export const singletonManager = new SingletonManagerClass();
